import axios from 'axios';
import Cookies from 'js-cookie';

const API_BASE_URL = import.meta.env.VITE_BASE_URL + '/api';

// Inject JWT from cookie when present so PartialContentFilter sees admin / paying users.
const buildAuthHeaders = () => {
  const token = Cookies.get('jwtToken');
  return token ? { Authorization: `Bearer ${token}` } : {};
};

// 🔎 1. Fetch lista de proiecte (cu filtre paginare, titlu, autoritate etc.)
export const fetchProjects = async (filters) => {
  try {
    // Remove empty string values to avoid backend deserialization issues
    const numericKeys = ['estimatedValueMin', 'estimatedValueMax', 'paapYear'];
    const cleanedFilters = {};
    for (const [key, value] of Object.entries(filters)) {
      if (value !== '' && value !== null && value !== undefined) {
        cleanedFilters[key] = numericKeys.includes(key) ? Number(value) : value;
      }
    }
    const response = await axios.post(
      `${API_BASE_URL}/projects/search`,
      cleanedFilters,
    );
    return response.data;
  } catch (error) {
    console.error('Eroare la fetchProjects:', error);
    throw error;
  }
};

// 📄 2. Fetch proiect individual după ID
// Backend may return `isPartial: true` for free users (PartialContentFilter).
// We keep the whole response object as-is so the UI can show the paywall when needed.
export const getProjectById = async (id) => {
  try {
    const response = await axios.get(`${API_BASE_URL}/projects/${id}`, {
      headers: buildAuthHeaders(),
    });
    return {
      ...response.data,
      isPartial: response.data?.isPartial || response.data?.IsPartial || false,
    };
  } catch (error) {
    console.error('Eroare la getProjectById:', error);
    throw error;
  }
};

// 🔗 3. Verifică dacă o procedură face parte dintr-un proiect
export const getProjectByAuctionId = async (auctionId) => {
  try {
    const response = await axios.get(
      `${API_BASE_URL}/projects/by-auction/${auctionId}`,
      { headers: buildAuthHeaders() },
    );
    return response.data;
  } catch (error) {
    console.error('Eroare la getProjectByAuctionId:', error);
    return { found: false };
  }
};

/**
 * 🔗 4. Batch lookup — returnează un dictionary { auctionId: projectInfo | null }
 * pentru toate auctionId-urile cerute. Un singur request în locul unui request per item.
 * Folosit de list pages (AuctionList, DirectAwardList etc.) ca să evite N+1.
 */
export const getProjectsByAuctionIds = async (auctionIds) => {
  try {
    const ids = (auctionIds || []).filter(Boolean);
    if (ids.length === 0) return {};
    const response = await axios.post(
      `${API_BASE_URL}/projects/by-auctions`,
      { auctionIds: ids },
      { headers: buildAuthHeaders() },
    );
    return response.data || {};
  } catch (error) {
    console.error('Eroare la getProjectsByAuctionIds:', error);
    return {};
  }
};
